import { render, staticRenderFns } from "./instAGREEMENT_ALL.vue?vue&type=template&id=15e04ce4&scoped=true"
import script from "./instAGREEMENT_ALL.vue?vue&type=script&lang=js"
export * from "./instAGREEMENT_ALL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e04ce4",
  null
  
)

export default component.exports